import React, { useState, useEffect } from 'react';
import PageLayout from '../../../layouts/PageLayout';
import { PATH_DASHBOARD } from '../../../routes/paths';
import { Box, Grid, Stack } from '@mui/material';
import useOrderPage from './useOrderPage';
import OrderDetailCard from '../../../components/platform/orders/OrderDetailCard';
import { useParams } from 'react-router';
import ShippingDetails from '../../../components/platform/orders/ShippingDetails';
import OrderDocumentContainer from '../../../components/platform/orders/OrderDocumentContainer';
import OrderNotes from '../../../components/platform/orders/OrderNotes';
import Send2ShipmentModal from '../../../modals/Orders/ShipmentModals/Send2ShipmentModal';

const OrderPage = () => {

    const {
        loading,
        error,
        order,
        modalManager,
        onGetOrder,
        onChange2PendingShipment,
        onDeliver
    } = useOrderPage()

    const {idorder} = useParams()

    return ( 
        <PageLayout stretch={true}
            title={`Orden #${idorder}`}
            title_seo={`Orden #${idorder} | Celu`}
            loading={loading}
            enable_return
            
            links={[
                {name:'Dashboard', href:PATH_DASHBOARD.general.app},
                {name:'Órdenes', href:PATH_DASHBOARD.general.users},
                {name:`Detalles`, },
            ]}
        >
            <div>
                <Box>
                    <Grid container spacing={2}>
                        <Grid item xs={12} md={8}>
                            <OrderDetailCard 
                                order={order}
                                onPendingShipment={onChange2PendingShipment}
                                onShip={() => modalManager.onChangeModalStatus('shipment_modal', true)}
                                onUpdateShip={() => modalManager.onChangeModalStatus('update_shipment_modal', true)}
                                onDeliver={onDeliver}
                            />
                        </Grid>
                        <Grid item xs={12} md={4}>
                            <Stack spacing={2}>
                                <OrderNotes order={order}/>
                                <ShippingDetails 
                                    order={order}
                                    onUpdateShip={() => modalManager.onChangeModalStatus('update_shipment_modal', true)}
                                    
                                />
                                <OrderDocumentContainer order={order} />
                            </Stack>
                        </Grid>
                    </Grid>
                    
                </Box>
                <Send2ShipmentModal
                    open={modalManager.modals.update_shipment_modal} mode='edit'
                    order={order} 
                    onRefresh={onGetOrder}
                    onClose={() => modalManager.onChangeModalStatus('update_shipment_modal', false)} 
                />
                <Send2ShipmentModal
                    open={modalManager.modals.shipment_modal} 
                    order={order} 
                    onRefresh={onGetOrder}
                    onClose={() => modalManager.onChangeModalStatus('shipment_modal', false)} 
                />
            </div>

        </PageLayout>

     );
}
 
export default OrderPage;